const functions = {
  usage_account_menu: {
    aws: true,
    azure: false,
    gcp: false,
  },
  usage_account_menu_budget: {
    aws: true,
    azure: false,
    gcp: false,
  },
  usage_account_menu_budget_edit: {
    aws: true,
    azure: false,
    gcp: false,
  },
  usage_account_menu_fees_credit: {
    aws: true,
    azure: true,
    gcp: false,
  },
  usage_account_menu_fees_fee: {
    aws: true,
    azure: true,
    gcp: false,
  },
  usage_account_menu_fees_refund: {
    aws: true,
    azure: true,
    gcp: false,
  },
  usage_account_menu_fees_other_fees: {
    aws: true,
    azure: true,
    gcp: false,
  },
  usage_report_download: {
    aws: true,
    azure: true,
    gcp: false,
  },
  usage_tag: {
    aws: true,
    azure: false,
    gcp: false,
  },
  ri_management: {
    aws: false,
    azure: true,
    gcp: false,
  },
  ri_purchased: {
    aws: true,
    azure: false,
    gcp: false,
  },
  ri_utilization: {
    aws: true,
    azure: false,
    gcp: false,
  },
  ri_recommendation: {
    aws: true,
    azure: false,
    gcp: false,
  },
  sp_purchased: {
    aws: true,
    azure: false,
    gcp: false,
  },
  report_filters: {
    aws: true,
    azure: false,
    gcp: false,
  },
};

import store from '@/vuex/vuex';
export default target => {
  /**
   * metaによる表示・非表示
   * @return Boolean
   */
  const handlingByMeta = name => {
    //const meta = store.state.userMeta;
    let meta;
    // DevTools
    const devToolsEnabled = store.state.devTools.isEnabled;
    if (devToolsEnabled) {
      meta = store.getters['devTools/getFunctions'];
    } else {
      meta = store.state.userMeta;
    }

    if (meta[name] === undefined && name !== 'report_filters') return true;
    return meta[name];
  };

  /**
   * Vendorによる表示・非表示
   * @return Boolean
   */
  const handlingByVendor = name => {
    const currentVendor = store.state.vendor;

    if (functions[name] === undefined) return true;
    return functions[name][currentVendor];
  };

  return handlingByMeta(target) && handlingByVendor(target);
};
